import React from "react";
import CustomHorizontalSpace from "../../Assistants/SpaceAssistant";
import {Grid} from "@mui/material";
import "./Homepage.css"
import OverviewImmunoClustProps from "./OverviewImmunoClustProps";
import OverViewImmunoClustPropsColumn from "./OverViewImmunoClustPropsColumn";
import IcapTitle from "../../Assistants/IcapTitle";


export function HeroImmunoClust() {

    return <>
        <IcapTitle/>
        <CustomHorizontalSpace space={50}/>
        <Grid container >
            <Grid item xs={12} md={7} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Grid container direction={'column'}>
                    <Grid className="overviewProps" >
                        <OverviewImmunoClustProps />
                    </Grid>
                    <Grid className="overviewPropsColumn" >
                        <OverViewImmunoClustPropsColumn  />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={5} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Grid container direction={'column'}>
                        <CustomHorizontalSpace space={100}/>
                        <Grid item xs={12} style={{display:'flex', justifyContent:'center', paddingRight:"10%"}}>
                            <ul className="custom-list">
                                <li>
                                    <i className="fas fa-check-circle list-icon"></i>
                                    <p>Modern adapted cluster algorithms enable reliable and reproducible population detection for flow cytometry data </p>
                                </li>
                                <li>
                                    <i className="fas fa-check-circle list-icon"></i>
                                    <p>A co-clustering algorithm with integrated normalization method leads to the detection of stable populations that are comparable across samples </p>
                                </li>
                                <li>
                                    <i className="fas fa-check-circle list-icon"></i>
                                    <p>Co-clustering with an analysis model enables the sequential analysis of additional samples for diagnostics </p>
                                </li>
                                <li>
                                    <i className="fas fa-check-circle list-icon"></i>
                                    <p>Cloud computing allows for high throughput of many samples </p>
                                </li>
                            </ul>
                        </Grid>
                </Grid>
            </Grid>
        </Grid>
    </>
}

export default HeroImmunoClust